import React, { useContext } from 'react';
import AppContext from '@context';
import { JourneysStateInterface } from '@context/reducers';
import { DetailsPropsInterface } from './DetailsTypes';
import Section from './Section';
import Skeleton from './Skeleton';

function Details({ details }: DetailsPropsInterface) {
  const {
    state: { journeys },
  } = useContext(AppContext);
  const { isFetching } =
    journeys.selection as JourneysStateInterface['selection'];

  if (isFetching) {
    return <Skeleton />;
  }

  if (!details) {
    return null;
  }

  return (
    <>
      <Section
        title="Informações da carga"
        infos={{
          type: 'cargo',
          data: details.cargo,
        }}
      />
      <Section
        title="Informações do veículo"
        infos={{
          type: 'vehicle',
          data: details.vehicle,
        }}
      />
      <Section
        title="Pagamento"
        infos={{
          type: 'payment',
          data: details.payment,
        }}
      />
    </>
  );
}

export default Details;
